// Ported from src/scripts/data/icons.js — megaphone broadcasting to followers
export function SpreadIt({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 11v2a1 1 0 0 0 1 1h2l5 4V6L6 10H4a1 1 0 0 0-1 1z" />
      <path d="M15 8c1.3 1 2 2.4 2 4s-.7 3-2 4" />
      <path d="M18 5.5c2 1.5 3 4 3 6.5s-1 5-3 6.5" />
    </svg>
  );
}
